import React, { useState } from "react";
import { Icon } from "@iconify/react";
import {
  Chip,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import CustomMUITable from "../../components/GeneralComponents/CustomMUITable/CustomMUITable";
import {
  _add_shipment_transit,
  _delete_shipment_transit,
  _list_shipment_transit_by_shipment,
  _update_shipment_transit,
} from "../../DAL/Shipment/shipment_transit/shipment_transit";
import { _list_shipment } from "../../DAL/Shipment/shipment";
import { useEffect } from "react";
import { _get_extra_expanses_list } from "../../DAL/extra_expense/extra_expense";
import { useSnackbar } from "notistack";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { useRef } from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import {
  _list_orders,
  _list_orders_with_status,
} from "../../DAL/orders/orders";
import CustomPopover from "../../components/GeneralComponents/CustomPopover";
import OrderDetail from "../Orders/OrderDetail";
import { find_order_color } from "../../utils/constant";

export default function SalesReport() {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const contentRef = useRef(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchText, setSearchText] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [reset, setReset] = useState(0);
  const [pageStatus, setPageStatus] = useState(0);
  const [rowsPerPageStatus, setRowsPerPageStatus] = useState(50);
  const [totalCountStatus, setTotalCountStatus] = useState(0);
  const [isLoadingForm, setIsLoadingForm] = useState(false);
  const [inputs, setInputs] = useState({
    start_date: dayjs(new Date()),
    end_date: dayjs(new Date()),
    status: "",
  });
  const [value, setValue] = useState();
  const [showPop, setshowPop] = useState(false);
  const [orderDetail, setOrderDetail] = useState("");
  const [ordersData, setOrdersData] = useState([]);
  const [data, setData] = useState(ordersData);
  const [subTotal, setSubTotal] = useState();
  const [discount, setDiscount] = useState();
  const [grandTotal, setGrandTotal] = useState();
  const TABLE_HEAD = [
    { id: "number", label: "#", alignRight: false, type: "number" },
    {
      label: "Order#",
      alignRight: false,
      renderData: (row) => {
        return (
          <Tooltip title="View Order Detail" placement="bottom-end" arrow>
            <Typography
              className="cursor-table"
              fontSize="25"
              onClick={() => {
                handleOpenPopup(row);
              }}>
              {row.order_id}
            </Typography>
          </Tooltip>
        );
      },
    },
    { id: "customer_info", label: "Customer", alignRight: false },
    { id: "total_price", label: "Total Cost", alignRight: false },
    { id: "discount", label: "Discount", alignRight: false },
    { id: "net_amount", label: "Net Amount", alignRight: false },
    { id: "order_date", label: "Date", alignRight: false },
    {
      id: "status",
      label: "Status",
      alignRight: false,
      renderData: (row) => {
        let chipColor = find_order_color(row.order_status);
        return (
          <Chip
            label={row.order_status}
            style={{ backgroundColor: chipColor }}></Chip>
        );
      },
    },
  ];

  const handleDateChange = (name, value) => {
    setInputs((prevState) => {
      return {
        ...prevState,
        [name]: dayjs(value.$d),
      };
    });
  };
  const handleSubmit = async (e) => {
    setIsLoadingForm(true);
    e.preventDefault();
    setValue(inputs.status);
  };
  const handleDownloadPDF = () => {
    setIsLoadingButton(true);
    const pdf = new jsPDF("p", "pt", "a4");

    // Add the image
    const imageX = 40;
    const imageY = 8;
    const imageWidth = 50;
    const imageHeight = 30;
    const imageURL =
      "data:image/png;base64,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";
    pdf.addImage(imageURL, "JPEG", imageX, imageY, imageWidth, imageHeight);

    //pdf heading
    pdf.setFontSize(20);
    const reportTitle = "Sales Report";
    const titleWidth = pdf.getTextWidth(reportTitle);
    // const titleX = (pdf.internal.pageSize.getWidth() - 90) / 2; // Calculate the starting position 90 ki jga titlewidth
    const titleX = 100;
    pdf.text(titleX, 32, reportTitle);

    // Add the start and end dates box
    const datesBoxWidth = 140;
    const datesBoxHeight = 40;
    const datesBoxX = 40;
    const datesBoxY = 60;
    pdf.setDrawColor(255, 255, 255);
    pdf.rect(datesBoxX, datesBoxY, datesBoxWidth, datesBoxHeight, "S");
    pdf.setFontSize(10);
    pdf.setTextColor(0, 0, 0);
    pdf.setFont(undefined, "bold");
    pdf.text("Start Date:", datesBoxX + 5, datesBoxY + 13);
    pdf.text("End Date:", datesBoxX + 5, datesBoxY + 30);
    pdf.setFont(undefined, "normal");
    pdf.text(
      `${moment(inputs.start_date.$d).format("dddd, MMMM Do YYYY")}`,
      datesBoxX + 70,
      datesBoxY + 13
    );
    pdf.text(
      `${moment(inputs.end_date.$d).format("dddd, MMMM Do YYYY")}`,
      datesBoxX + 70,
      datesBoxY + 30
    );

    // Payment box
    const boxWidth = 140;
    const boxHeight = 57;
    const boxMarginRight = 40; // Adjust the right margin
    const boxX = pdf.internal.pageSize.getWidth() - boxWidth - boxMarginRight;
    const boxY = datesBoxY;
    pdf.setDrawColor(255, 255, 255);
    pdf.rect(boxX, boxY, boxWidth, boxHeight, "S");
    pdf.setFontSize(10);
    pdf.setTextColor(0, 0, 0);
    pdf.setFont(undefined, "bold");
    pdf.text("Sub Total:", boxX + 5, boxY + 13);
    pdf.text("Total Discount:", boxX + 5, boxY + 30);
    pdf.text("Grand Total: ", boxX + 5, boxY + 50);
    pdf.setFont(undefined, "normal");
    pdf.text(`$${subTotal}`, boxX + 78, boxY + 13);
    pdf.text(`$${discount}`, boxX + 80, boxY + 30);
    pdf.text(`$${grandTotal}`, boxX + 81, boxY + 50);

    // Add a horizontal line between "Grand Total" and "Total Discount"
    const lineY = boxY + 38;
    const lineXStart = boxX - 2;
    const lineXEnd = boxX + boxWidth - 5;
    pdf.setLineWidth(2);
    pdf.setDrawColor(25, 97, 222); // Blue color
    pdf.line(lineXStart, lineY, lineXEnd, lineY);

    //table data
    const startY = datesBoxY + datesBoxHeight + 20; // Adjust startY value
    // Set the table headers
    const headers = [
      "No.",
      "Order#",
      "Customer",
      "Total Cost",
      "Discount",
      "Net Amount",
      "Order Date",
    ];
    const table_data = data.map((row, index) => [
      index + 1,
      row.order_id,
      row.customer_info,
      row.total_price,
      row.discount,
      row.net_amount,
      row.order_date,
    ]);
    const options = {
      startY,
      margin: { top: 30 },
      theme: "grid", // Set the table theme to striped
      headStyles: { fillColor: [25, 97, 222], textColor: [255, 255, 255] }, // Blue header color
      columnStyles: {
        4: { cellWidth: 60 },
        2: { cellWidth: 140 },
      },
    };
    pdf.autoTable(headers, table_data, options);

    pdf.save("SalesReport.pdf");
    setIsLoadingButton(false);
  };
  // order listing
  const get_orders_data = async () => {
    setIsLoading(true);
    const response = await _list_orders(page, rowsPerPage, searchText);
    if (response.code === 200) {
      let data = response.order.map((order) => {
        let user_name = "";
        if (order.customer?.first_name) {
          user_name = order.customer?.first_name;
          if (order.customer?.last_name) {
            user_name = user_name + " " + order.customer?.last_name;
            if (order?.email) {
              user_name = user_name + " (" + order?.email + ")";
            }
          } else {
            if (order?.email) {
              user_name = user_name + " (" + order?.email + ")";
            }
          }
        } else {
          user_name = "Guest User";
        }
        let totalPrice = 0;
        if (order.order_total_without_discount) {
          totalPrice = order.order_total_without_discount.toFixed(2);
        } else {
          totalPrice = totalPrice.toFixed(2);
        }
        let netAmount = 0;
        if (order.total_price_after_discount) {
          netAmount = order.total_price_after_discount.toFixed(2);
        } else {
          netAmount = netAmount.toFixed(2);
        }
        let discountAmount = 0.0;
        if (order.total_order_discount) {
          discountAmount = order.total_order_discount.toFixed(2);
        } else {
          discountAmount = discountAmount.toFixed(2);
        }
        return {
          ...order,
          customer_info: user_name,
          order_date: moment(order.createdAt).format("DD-MM-YYYY"),
          total_price: "$" + totalPrice,
          shipping_state: order.billing_info?.states,
          discount: "$" + discountAmount,
          net_amount: "$" + netAmount,
        };
      });
      setTotalCount(response.total_count);
      setOrdersData(data);
      setData(data);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  // orders listing with status
  const get_orders_data_with_status = async () => {
    setIsLoading(true);
    const response = await _list_orders_with_status(
      pageStatus,
      rowsPerPageStatus,
      value
    );
    if (response.code === 200) {
      let data = response.order.map((order) => {
        let user_name = "";
        if (order.customer?.first_name) {
          user_name = order.customer?.first_name;
          if (order.customer?.last_name) {
            user_name = user_name + " " + order.customer?.last_name;
            if (order?.email) {
              user_name = user_name + " (" + order?.email + ")";
            }
          } else {
            if (order?.email) {
              user_name = user_name + " (" + order?.email + ")";
            }
          }
        } else {
          user_name = "Guest User";
        }
        let totalPrice = 0;
        if (order.order_total_without_discount) {
          totalPrice = order.order_total_without_discount.toFixed(2);
        } else {
          totalPrice = totalPrice.toFixed(2);
        }
        let netAmount = 0;
        if (order.total_price_after_discount) {
          netAmount = order.total_price_after_discount.toFixed(2);
        } else {
          netAmount = netAmount.toFixed(2);
        }
        let discountAmount = 0.0;
        if (order.total_order_discount) {
          discountAmount = order.total_order_discount.toFixed(2);
        } else {
          discountAmount = discountAmount.toFixed(2);
        }
        return {
          ...order,
          customer_info: user_name,
          order_date: moment(order.createdAt).format("DD-MM-YYYY"),
          total_price: "$" + totalPrice,
          shipping_state: order.billing_info?.states,
          discount: "$" + discountAmount,
          net_amount: "$" + netAmount,
        };
      });
      setTotalCountStatus(response.total_count);
      setOrdersData(data);
      setData(data);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  const handleOpenPopup = (row) => {
    setOrderDetail(row);
    handlePrivilegesPopups();
  };
  const handlePrivilegesPopups = () => {
    setshowPop(true);
  };
  // pages handling without Filters
  const searchFunction = () => {
    setPage(0);
    get_orders_data();
    setInputs((values) => ({ ...values, ["status"]: "" }));
  };
  const searchResetFunction = () => {
    setValue();
    setInputs((values) => ({ ...values, ["status"]: "" }));

    setSearchText("");
    setPage(0);
    if (reset === 0) {
      setReset(1);
    } else {
      setReset(0);
    }
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  // pages handling for filters
  const handleChangeRowsPerPageStatus = (event) => {
    setRowsPerPageStatus(parseInt(event.target.value, 10));
    setPageStatus(0);
  };
  const handleChangePageStatus = (event, newPage) => {
    setPageStatus(newPage);
  };
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  useEffect(() => {
    get_orders_data();
  }, [page, rowsPerPage, reset]);

  useEffect(() => {
    if (value) {
      get_orders_data_with_status();
    }
  }, [value, pageStatus, rowsPerPageStatus]);

  useEffect(() => {
    //  sub total
    let sub_total = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].order_total_without_discount) {
        let total = parseFloat(data[i].order_total_without_discount);
        sub_total += total;
      } else {
        let total = 0;
        sub_total += total;
      }
    }
    let subTotalPrice = sub_total.toFixed(2);
    setSubTotal(subTotalPrice);

    // total discount in bottom
    let discountAmount = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].total_order_discount) {
        let discountTotal = parseFloat(data[i].total_order_discount);
        discountAmount += discountTotal;
      } else {
        let discountTotal = 0;
        discountAmount += discountTotal;
      }
    }
    let discountTotal = discountAmount.toFixed(2);
    setDiscount(discountTotal);

    // grand total in bottom
    let totalAmount = 0;
    totalAmount = parseFloat(subTotalPrice) + parseFloat(discountTotal);
    let grandTotalAmount = totalAmount.toFixed(2);
    setGrandTotal(grandTotalAmount);
  }, [data]);
  console.log(inputs, "inputs");
  return (
    <>
      <div className="container" ref={contentRef} px-4>
        <div className="row">
          <div className="col-lg-8 col-sm-12 mt-3">
            <h3>Sales Report</h3>
          </div>
        </div>
        <div data-html2canvas-ignore="true" className="row mt-2 mb-4">
          <form
            autoComplete="off"
            onSubmit={handleSubmit}
            encType="multipart/form-data">
            <div className="row">
              <div className="col-xs-12 col-md-3 mt-2">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Start Date"
                    format="DD-MM-YYYY"
                    className="form-control"
                    name="start_date"
                    value={inputs?.start_date}
                    onChange={(e) => {
                      handleDateChange("start_date", e);
                    }}
                  />
                </LocalizationProvider>
              </div>
              <div className="col-xs-12 col-md-3 mt-2">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="End Date"
                    format="DD-MM-YYYY"
                    className="form-control"
                    name="end_date"
                    value={inputs?.end_date}
                    onChange={(e) => {
                      handleDateChange("end_date", e);
                    }}
                  />
                </LocalizationProvider>
              </div>
              <div className="col-xs-12 col-md-3 mt-2">
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel id="demo-simple-select-label">
                    Order Status *
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="status"
                    value={inputs.status}
                    required
                    label="Order Status"
                    onChange={handleChange}>
                    <MenuItem value="pending">Pending </MenuItem>
                    <MenuItem value="ready_to_ship">Ready to Ship</MenuItem>
                    <MenuItem value="shipped">Shipped</MenuItem>
                    <MenuItem value="delivered">Delivered</MenuItem>
                    <MenuItem value="cancelled">Cancelled</MenuItem>
                    <MenuItem value="returned">Returned</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="col-xs-12 col-md-2 mt-4 text-end">
                <button
                  className="small-contained-button"
                  type="submit"
                  //   disabled={isLoadingForm}
                >
                  {/* {isLoadingForm
                    ? "Submitting...": "Submit"} */}
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>

        {isLoading ? (
          <>
            <CircularProgress className="centerd" color="primary" />
          </>
        ) : (
          <>
            {value ? (
              <div className="row">
                <div className="col-12">
                  <CustomMUITable
                    TABLE_HEAD={TABLE_HEAD}
                    data={data}
                    className="card-with-background"
                    custom_pagination={{
                      total_count: totalCountStatus,
                      rows_per_page: rowsPerPageStatus,
                      page: pageStatus,
                      handleChangePage: handleChangePageStatus,
                      onRowsPerPageChange: handleChangeRowsPerPageStatus,
                    }}
                    custom_search={{
                      searchText: searchText,
                      setSearchText: setSearchText,
                      handleSubmit: searchFunction,
                      handleReset: searchResetFunction,
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-12">
                  <CustomMUITable
                    TABLE_HEAD={TABLE_HEAD}
                    data={data}
                    className="card-with-background"
                    custom_pagination={{
                      total_count: totalCount,
                      rows_per_page: rowsPerPage,
                      page: page,
                      handleChangePage: handleChangePage,
                      onRowsPerPageChange: handleChangeRowsPerPage,
                    }}
                    custom_search={{
                      searchText: searchText,
                      setSearchText: setSearchText,
                      handleSubmit: searchFunction,
                      handleReset: searchResetFunction,
                    }}
                  />
                </div>
              </div>
            )}

            <div className="row  mt-4 px-1">
              <div className="col-7"></div>
              <div className="col-5 border-div payment-box text-end">
                <div className="justify-content-between d-flex">
                  <div>
                    <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>
                      Sub Total:{" "}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      sx={{ fontSize: "14px" }}>{`$${subTotal}`}</Typography>
                  </div>
                </div>
                <div className="mt-2 justify-content-between d-flex">
                  <div>
                    <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>
                      Total Discount:{" "}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      sx={{ fontSize: "14px" }}>{`$${discount}`}</Typography>
                  </div>
                </div>

                <div className="mt-2 mb-2 justify-content-between d-flex">
                  <div>
                    <Typography
                      sx={{ mr: 12, fontWeight: "bold", fontSize: "14px" }}>
                      Grand Total:{" "}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      sx={{ fontSize: "14px" }}>{`$${grandTotal}`}</Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12 text-end" data-html2canvas-ignore="true">
                <button
                  className="small-contained-button"
                  style={{
                    marginLeft: "10px",
                    backgroundColor: "rgb(25, 97, 222)",
                  }}
                  onClick={handleDownloadPDF}>
                  <Icon
                    icon="ic:baseline-sim-card-download"
                    style={{ width: 20, height: 15, marginRight: 3 }}
                  />
                  {isLoadingButton ? "Downloading..." : "Generate PDF"}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <CustomPopover
        isOpenPop={showPop}
        isClosePop={setshowPop}
        title={"Order Detail"}
        status={orderDetail.order_status}
        componentToPassDown={<OrderDetail orderDetail={orderDetail} />}
      />
    </>
  );
}
